export const CHART_HEIGHT = 300;
export const CHART_HEIGHT_MOBILE = 225;

export const isEmptyArray = (data: unknown): boolean => {
  return !data || (Array.isArray(data) && data.length === 0);
};

export const shiftDate = (date: Date | string, numDays: number): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + numDays);
  return newDate;
};

interface NivoTheme {
  fontSize: number;
}

export const getNivoTheme = (isMobile: boolean): NivoTheme => ({
  fontSize: isMobile ? 8 : 11,
});